export class CompanyPolicyVersionHistoryModel {
    public id: number;
    public version: string;
    public versionNotes: string;
    public fileName: string;
    public fileUrl: string;
    public isCurrentVersion: boolean;
}
